import tj from "./tj/en-US";
const en_US = {
  "intl.hello": "hello",
  "intl.name": "my name is {name}",
  "intl-Nav-Home": "Home",
  "intl-Nav-Center": "Center Overview",
  "intl-Nav-Activities": "Events and Programs",
  "intl-Nav-News": "News",
  "intl-Nav-AboutUs": "Information",
  "intl-Nav-Login": "Login",
  "intl-Nav-Register": "Register",
  "intl-Menu-Email": "Email",
  "intl-Menu-Phone": "Phone",
  "intl-Menu-Hours": "Hours",
  "intl-Home-AboutUs": "Lenovo Future Center",
  "intl-Home-Character":
    "Alienum phaedrum torquatos nec eu, vis detraxit periculis ex, nihil expetendis in mei.\n" +
    "                            Mei an pericula euripidis, hinc partem ei est. Eos ei nisl graecis, vix aperiri\n" +
    "                            consequat an. Eius lorem tincidunt vix at, vel pertinax sensibus id,\n" +
    "                            error epicurei mea et. Mea facilisis urbanitas moderatius id. Vis ei rationibus\n" +
    "                            definiebas, eu qui purto zril laoreet. Ex error omnium interpretaris pro, alia illum\n" +
    "                            eavim.",

  "intl-Home-aboutPart1":
    "Lenovo Future Center is a bridge that uses smart technology to connect China to the world, the present to the future, and reality to imagination.",
  "intl-Home-aboutPart2": "Here, ",
  "intl-Home-aboutPart3": "We let you experience a full smart lifestyle. ",
  "intl-Home-aboutPart4":
    "We provide enterprises with approaches and methods for intelligent transformation. ",
  "intl-Home-aboutPart5":
    "We seek integrated solutions for industries going through smart revolutions.",
  "intl-Home-aboutPart6":
    "We improve society through the innovative ideas of the future.",
  "intl-Home-JOINLENOVO": "Get to the future",
  "intl-Home-Sun": "Sun",
  "intl-Home-Mon": "Mon",
  "intl-Home-Tue": "Tue",
  "intl-Home-Wed": "Wed",
  "intl-Home-Thu": "Thu",
  "intl-Home-Fir": "Fri",
  "intl-Home-Sat": "Sat",
  "intl-Home-Mayapply": "Available",
  "intl-Home-Application": "Occupied",
  "intl-Home-ACITIVITES": "ACITIVITES",
  "intl-Home-Ipsum":
    "Ipsum lorem ad sea, in reque bonorum definiebas mei. Ius causae conclusionemque in. Sea ex nemore eirmoddelicatissim.",
  "intl-Home-development": "DEVELOPMENT",
  "intl-Home-CREATING": "CREATING A STRATEGY",
  "intl-Home-REVOLUTION": "REVOLUTION SLIDER",
  "intl-Home-Alienum":
    "Alienum phaedrum torquatos nec eu, vis detraxit periculis ex, nihil expetendis in mei. Mei an pericula euripidis, hinc partem ei est.",
  "intl-Home-MORE": "Read more",
  "intl-AboutUS-ABOUTSUS ": "Information",
  "intl-AboutUS-title1": "We want to give you the best visiting experience.",
  "intl-AboutUS-title2": "A place to understand Lenovo, and our future.",
  "intl-AboutUS-happened ": "What is happened ?",

  "intl-AboutUS-Paragraph1 ":
    "After association 30" +
    "After years of development, the company has grown from a Chinese company to a global multinational company, and its business has been transformed from a single business to a diversified business, and at the same time from a global PC" +
    "The industry leader gradually evolves into an industrial builder based on equipment + cloudandinfrastructure + cloud, and provides a wide range of intelligent equipment, services and people around the world with a wide range of intelligent equipment manufacturing, service capabilities and supercomputing power construction capabilities",

  "intl-AboutUS-Paragraph2":
    "Lenovo innovation demonstration center through > innovation exhibition center through the smart life scene of lenovo products and the use of science and technology, focusing on the future smart home, intelligent work travel, smart and intelligent entertainment content, and through the platform based on Internet and artificial intelligence algorithm, the formation of the technical support of intelligent life as a whole.",

  "intl-AboutUS-Paragraph3":
    "Display of intelligent industry, through the construction of computing power, big data and algorithm platform, the content of the intelligent manufacturing, intelligent medical, financial intelligence education, intelligence and wisdom city, such as the intelligent energy industry system solutions and technical breakthrough, from all walks of life to systematically display in the development of intelligence industry, lenovo enabler status and leading technology.",
  "intl-AboutUS-Paragraph4":
    "Lenovo innovation display center can help you >Lenovo innovation display center can help you connect the world's 'imagination', leading you into lenovo's smart future world.",
  "intl-AboutUS-Paragraph5":
    "Lenovo innovation exhibition center can help you connect the imagination of the world and lead you into lenovo's intelligent future world.",
  "intl-AboutUS-Introduction": "Visitor Information",
  "intl-AboutUS-Admissions": "Hours",
  "intl-AboutUS-Facilities": "Facilities",
  "intl-AboutUS-FAQ": "FAQ",
  "intl-AboutUS-Directions": "Directions",
  "intl-AboutUS-operationGuide": "Lenovo VLEC operation guide",
  "intl-AboutUS-Hours": "Opening Hours",
  "intl-AboutUS-TheTimeThat":
    "- Mondays – Saturdays: 9:00 am – 6:00 pm (reservation needed)",
  "intl-shAboutUS-TheTimeThat":
    "- Mondays – Fridays: 9:00 am – 6:00 pm (reservation required)",
  "intl-AboutUS-TheTimeThat1":
    "- Saturday: 9a.m. - 5p.m. (Last Admission by 4:30p.m.)",
  "intl-AboutUS-Closed": "Closed",
  "intl-AboutUS-ClosedTime": "- Sundays",
  "intl-AboutUS-ClosedTime1": "- Public holidays",
  "intl-AboutUS-Museum": "Venue guide",
  "intl-AboutUS-Weekdays": "- Weekdays",
  "intl-AboutUS-Weekdays1": "Reservation required (Guided tour by venue staff)",
  "intl-AboutUS-Weekdays2":
    " ※ All weekday visits must be reserved in advance.",
  "intl-AboutUS-Weekdays3":
    "※ Guided tours can take up to 30 people per group. (If your group'exceeds 30 people, it will be divided into smaller groups of maximum 30 people.)",
  "intl-aboutus-reservations": "Reservations",
  "intl-aboutus-notes": "Notes",
  "intl-aboutus-prohibited": "Prohibited Items",
  "intl-AboutUS-Saturdays": "- Saturdays",
  "intl-AboutUS-Saturdays1": "- No reservation required ",
  "intl-AboutUS-Saturdays2": " ※ There is no guided tour on Saturdays",
  "intl-AboutUS-VisitorsGuide": "  Visitor's Guide",
  "intl-AboutUS-VisitorsGuide1":
    "  •	Reservations are only available for group visits.",
  "intl-AboutUS-VisitorsGuide2":
    "  •	Reservations require at least 10 days notice.",
  "intl-AboutUS-VisitorsGuide3":
    "  •	You will receive an email notification if your reservation succeeds.",
  "intl-AboutUS-VisitorsGuide4":
    "  •  Group tours are capped at 30 people to ensure tour quality.",
  "intl-szAboutUS-VisitorsGuide4":
    "  •  Group tours are capped at 20 people to ensure tour quality.",
  "intl-AboutUS-VisitorsGuide4-0":
    "•	Visitors under the age of 18 must be accompanied by at least one adult to enter the Lenovo Future Center.",
  "intl-AboutUS-VisitorsGuide4-1":
    "•	Visitors with difficulty walking need to be accompanied by able-bodied adults.",
  "intl-AboutUS-VisitorsGuide4-2":
    "•	Pets are not allowed in the Lenovo Future Center.",
  "intl-AboutUS-VisitorsGuide5":
    " •	To avoid disturing others, please mute your phone and talk in a low voice.",
  "intl-AboutUS-VisitorsGuide6":
    " •	Smoking and eating are prohibited in the Lenovo Future Center.",
  "intl-AboutUS-VisitorsGuide6-1":
    " •	Smoking and eating are prohibited in the Lenovo Future Center. ",
  "intl-AboutUS-VisitorsGuide7":
    " •	Damage to buildings, facilities and exhibits and drawing are not allowed.",
  "intl-AboutUS-VisitorsGuide8":
    " •	Do not run, chase, climb or lie down in the Lenovo Future Center.",
  "intl-AboutUS-VisitorsGuide9":
    " •	Do not run, chase, climb or lie down in the Lenovo Future Center.",
  "intl-AboutUS-VisitorsGuide10":
    " •	Please help maintain a positive environment in the Lenovo Future Center.",
  "intl-AboutUS-VisitorsGuide10-1": "※ Do not wear flip-flops",
  "intl-AboutUS-VisitorsGuide11":
    " •	For the safety of the exhibition items, photography and recording are allowed only in designated areas of the venue. (Please talk to the staff in advance if you wish to film a TV program in the Lenovo Future Center)",

  "intl-AboutUS- Facilities1": " Parking",
  "intl-AboutUS- Facilities1-1": "Reception",
  "intl-AboutUS- Facilities1-2": "Lockers",
  "intl-AboutUS- Facilities2":
    "Lenovo has a special parking area for visitors. From this parking area, visitors can walk 300 meters to reach the Lenovo Future Center. ",
  "intl-AboutUS- Facilities3":
    "•	Opening hours: Monday to Saturdays: 9:00 a.m. – 6:00 p.m.",
  "intl-AboutUS- Facilities4":
    "•	Reservations: Lenovo staff will communicate with you about parking reservations when you receive your visit confirmation.",
  "intl-AboutUS- Facilities5":
    "•	Parking location: Visitors should enter the parking structure from the west entrance of the Lenovo East Campus parking lot and follow the traffic instructions to reach the visitor parking area.",
  //
  "intl-AboutUS-Facilities6":
    "•	The reception desk is located at the Lenovo Future Center entrance.",
  "intl-AboutUS-Facilities7":
    "•	You can get neccessary asssistance at the reception desk.",
  "intl-AboutUS-Facilities8":
    "•	Hours: Monday to Saturdays: 9:00 a.m. - 6:00 p.m.",
  "intl-AboutUS-Facilities9":
    "•	Items left in the lockers after 6:00 p.m. will be removed and stored for 3 days. Items not claimed after 3 days will be discarded.",
  "intl-AboutUS-Facilities10":
    "•	Remember to take your belongings before leaving.",
  "intl-AboutUS-site": "Address: ",
  "intl-AboutUS-site1":
    "Lenovo HQ East, Building 1, Yard 10, Xibeiwang East Rd., Haidian District, Beijing",
  "intl-shAboutUS-site1":
    "5F, Block A, Lenovo Innovation Park, No. 696 Songtao Rd., Pudong New Area, Shanghai",
  "intl-AboutUS-Phone": "Subway: ",
  "intl-AboutUS-Phone1":
    "Take Metro Line 16 to Xibeiwang Station, exit at Exit C, and then walk 1.8 miles to Lenovo HQ East",

  "intl-Activities-NumberOfVisitors": "Group Information",
  "intl-Activities-NumberOfVisitors2": "Number of Visitors",
  "intl-Activities-Datails": "Contact Person",
  "intl-Activities-Confirmation": "Comfirmation",

  "intl-Activities-teamTitle":
    "We can provide customized tours and hold social activities.",
  "intl-Activities-Title": "Title",
  "intl-Activities-group": "Please provide group information",
  "intl-Activities-Individual": "*Please fill in the following blanks",
  "intl-Activities-CustomerInformation": "Group Information",
  "intl-Activities-VisitingPurpose": "Visiting purpose",
  "intl-Activities-GroupInfo": "Organization Description",
  "intl-Activities-VisitTime": "Expected visit time",
  "intl-Activities-CityCascade": "Visiting Area",
  "intl-Activities-Dateofvisit": "Date of Visit",
  "intl-Activities-VisitingTime": "Time of Visit",
  "intl-Activities-Subordinate": "Industry",
  "intl-Activities-Note": "Additional Information",
  "intl-Activities-purpose": "Cooperation Demand",
  "intl-Activities-otherPurpose": "Other demand",
  "intl-Activities-demandtxt": "please specify the demand",
  "intl-Activities-yycg": "Schedule Visit",
  "intl-Activities-hdzx": "Event Consulting",
  "intl-Activities-mthz": "Media Cooperation",
  "intl-Activities-qt": "Others",
  "intl-Activities-VisitTheUnit": "Organization",
  "intl-Activities-VisitGroup": "peopleGroup",
  "intl-Activities-VisitBumber": "Numbervisitors",
  "intl-Activities-City": "Region",
  "intl-Activities-language": "Briefing Language",
  "intl-Activities-language1": "Chinese",
  "intl-Activities-language4": "English",
  "intl-Activities-Next": "Next",
  "intl-Activities-Previous": "Previous",
  "intl-Activities-Submit": "Submit",
  "intl-Activities-tjxx": "Submit",
  "intl-Activities2-Please": "Please select the number of visitors",
  "intl-Activities2-Guided":
    "Group tours are capped at 30 people to ensure tour quality. Visitors under the age of 18 must be accompanied by at least one adult to enter the Lenovo Future Center.",
  "intl-Activities2-Number": "Number of Visitors",
  "intl-Activities2-Under": "Under the age of 12",
  "intl-Activities2-Students": "College Students",
  "intl-Activities2-Eighteen": " Age 13 to 18",
  "intl-Activities2-Adults": "Over the age of 18",
  "intl-Activities2-Total number of visitors ": "Total number of visitors ",
  "intl-Activities2-People": " ", //People
  "intl-Activities3-details": "Please provide visit details",
  "intl-Activities3-Information": "Contact Person",
  "intl-Activities3-name": "Name",
  "intl-Activities3-phone": "Mobile Phone Number",
  "intl-Activities3-E-mail": "E-mail",
  "intl-Activities3-Nationality": "Country",
  "intl-Activities3-Occupation": "Occupation",
  "intl-Activities3-China": "China",
  "intl-Activities3-TheBritish": "The British",
  "intl-Activities3-Japan": "Japan",
  "intl-Activities3-TheUnitedStates": "The United States",
  "intl-Activities3-I agree": "I agree",
  "intl-Activities3-I disagree": "I disagree",

  "intl-Activities5-Information": "Please confirm your information is correct.",
  "intl-Activities5-Contact": "Contact Person",

  "intl-InnovationCenter-InnovationCenter": "The exhibition hall is introduced",
  "intl-InnovationCenter-Ipsum":
    "Ipsum lorem ad sea, in reque bonorum definiebas mei. Ius causae conclusionemque in. Sea ex\n" +
    "                            nemore eirmoddelicatissim. Sea ex nemore eirmoddelicatissim.",
  "user-hello": "Hello,",
  "intl-Nav-Logout": "Logout",
  "send-verifycode": "Send",
  "upper-limit": "Upper limit",
  "intl-location": "Location",
  "intl-activityContent": "Content",
  "intl-agenda": "Scheduling",
  "intl-activityRule": "Rules",
  "intl-Publish-Date": "Publish Date",
  "intl-VisitorsInfo": "Visitors' Information",
  "intl-Operation": "Operation",
  "intl-viewdetail": "Detail",
  "intl-Activities3-InterestTopic": "Topics of Interest",
  "intl-inputNumer": "Please enter a number",
  "intl-agree-lenovoService":
    "I agree to the Terms and Conditions of the Lenovo service.",
  "intl-agree-personalInfo":
    "I agree to the collection and use of personal information.",
  "intl-agree-requiredPersonalInfo":
    "I agree to the collection and use of required personal information",
  "intl-agree-optionalPersonalInfo":
    "I agree to the collection and use of optional personal information",
  "intl-succeedTip":
    "We've received your information, and our staff will contact you by email within 3 working days to confirm your appointment. ",
  "intl-succeedTip2": "Please remember to check your inbox.",
  "intl-succeedTitle": "Congratulations, your information was sent. ",
  "intl-backHome": "Back",
  "intl-Nav-GroupApply": "Group Reservation",
  "intl-peopleNumber": "Pls enter an integer",
  "intl-qrTip":
    "Scan the QR code and pay attention to the Lenovo Future Center. Come and sign up.",
  "intl-welcome": "Welcome",
  "intl-GroupReservation": "Group Reservation",
  "intl-EventSignUp": "Event Sign-up",
  "intl-ActivityTip":
    "Tours are currently only available for group visits. If you would like to visit as an individual, please look for events on Events and Programs page.",
  "intl-checkTip":
    "I agree to the collection and use of the above information.",
  "intl-PrivacyPolicy": "Privacy Policy",
  "intl-ComingSoon": "Coming Soon",

  "intl-Activities5-Information": "Please confirm your information is correct.",
  "intl-Activities5-Contact": "Contact Person",


  "intl-InnovationCenter-InnovationCenter": "The exhibition hall is introduced",
  "intl-InnovationCenter-Ipsum": "Ipsum lorem ad sea, in reque bonorum definiebas mei. Ius causae conclusionemque in. Sea ex\n" +
    "                            nemore eirmoddelicatissim. Sea ex nemore eirmoddelicatissim.",
  "user-hello": "Hello,",
  "intl-Nav-Logout": "Logout",
  "send-verifycode": "Send",
  "upper-limit": "Upper limit",
  "intl-location": "Location",
  "intl-activityContent": "Content",
  "intl-agenda": "Scheduling",
  "intl-activityRule": "Rules",
  "intl-Publish-Date": "Publish Date",
  "intl-VisitorsInfo": "Visitors' Information",
  "intl-Operation": "Operation",
  "intl-viewdetail": "Detail",
  "intl-Activities3-InterestTopic": "Topics of Interest",
  "intl-inputNumer": "Please enter a number",
  "intl-agree-lenovoService": "I agree to the Terms and Conditions of the Lenovo service.",
  "intl-agree-personalInfo": "I agree to the collection and use of personal information.",
  "intl-agree-requiredPersonalInfo": "I agree to the collection and use of required personal information",
  "intl-agree-optionalPersonalInfo": "I agree to the collection and use of optional personal information",
  "intl-succeedTip": "We've received your information, and our staff will contact you by email within 3 working days to confirm your appointment. ",
  "intl-succeedTip2": "Please remember to check your inbox.",
  "intl-succeedTitle": "Congratulations, your information was sent. ",
  "intl-backHome": "Back",
  "intl-Nav-GroupApply": "Group Reservation",
  "intl-peopleNumber": "Pls enter an integer",
  "intl-qrTip": "Scan the QR code and pay attention to the Lenovo Future Center. Come and sign up.",
  "intl-welcome": "Welcome",
  "intl-GroupReservation": 'Group Reservation',
  "intl-EventSignUp": 'Event Sign-up',
  "intl-ActivityTip": 'Tours are currently only available for group visits. If you would like to visit as an individual, please look for events on Events and Programs page.',
  "intl-checkTip": "I agree to the collection and use of the above information.",
  "intl-PrivacyPolicy": "Privacy Policy",
  "intl-ComingSoon": "Coming Soon",

  "intl-Menu-Terms": "Terms of Use",
  "intl-Menu-Privacy": "Privacy Policy",
  "intl-Menu-Directions": "Directions",
  "intl-Menu-Links": "Links",
  "intl-Menu-Weibo": "Weibo",
  "intl-Menu-WeChat": "WeChat",
  "intl-Menu-Contact": "Contact: ",
  "intl-Menu-Address": "Address: Lenovo Beijing Future Center, Bldg. 1, No.10 Courtyard Xibeiwang East Road, Haidian District, Beijing, China",
  "intl-Menu-LenovoGroup": "Lenovo Group",
  "intl-Menu-LenovoStore": "Lenovo Store",
  "intl-home-month": "   ",
  "intl-home-year": " ",
  "intl-home-Possibilities1": "A place for Lenovo users, members and fans to get together",
  "intl-home-Possibilities2": "A place to focus on technology, culture, art and thought",
  "intl-home-Possibilities3": "Here, it’s not just Lenovo.",
  //center
  "intl-center-title": "Smarter Technology for All",
  "intl-center-title2": "Lenovo Future Center is a new landmark of science and technology, ",
  "intl-center-title2_1": "representing Lenovo’s power of innovation and thought leadership.",
  "intl-center-title3": "Lenovo Future Center has a total area of 6,500 square meters,",
  "intl-center-title3_1": "including multiple smart life scenarios and a range of industry solutions.",
  "intl-center-f1Title": "Lenovo Future Center, 1st floor — 3,000 m2",
  "intl-center-f1Title2": "Smart Lifestyle: Consumers",
  "intl-center-f1Des": "The first floor shows Lenovo’s achievements in internationalization, computation and data-driven decision-making and highlights Lenovo’s current and upcoming smart lifestyle experiences.",
  "intl-center-f2Title": "Lenovo Future Center, 2nd floor — 2,000 m2",
  "intl-center-f2Title2": "Smart Verticals: Commercial customers and partners",
  "intl-center-f2Des": "The second floor shows Lenovo’s smart solutions for commercial devices, data centers, and industries including manufacturing, healthcare and education.",
  "intl-center-f3Title": "Lenovo Future Center, 3rd floor — 1,000 m2",
  "intl-center-f3Title2": "Next Space",
  "intl-center-f3Des": "The Next Space is an open space to discuss cross-domain innovation and product releases. It serves as a space for activities related to science, technology, culture, art and more.",
  "intl-center-dataTitle": "Intelligent Flow",
  "intl-center-dataDes1": "Data is the fuel that drives smart transformation. Data helps devices interact naturally and efficiently so that services can flow freely between them.",
  "intl-center-dataDes2": "Lenovo Future Center's Energy Droplet recognizes visitors and lights up the whole center with Lenovo’s exclusive Intelligent Flow. The Intelligent Flow acts like a wave, flowing Lenovo’s computation and algorithmic power into the background of each user scenario to trigger smart transformations in our customers’ lifestyles and industries.",
  "intl-center-historyTitle": "History Corridor",
  "intl-center-historyDes1": "The History Corridor provides an immersive 3D experience on an 18-meter 210° screen, showing the history of data-driven and computation-driven human development starting from the time people kept records by tying knots.",
  "intl-center-historyDes2": "As science and technology have improved, Lenovo has continued to bring users high-quality products and services by perfectly integrating data and computation.",
  "intl-center-lifeTitle": "Future Home Experience",
  "intl-center-lifeDes1": "Lenovo's SIoT (Smart Internet of Things) cloud platform helps turn home devices into thoughtful servants, fully and seamlessly integrating their services into our lives. Whether our users want to watch TV, read, exercise, or eat, Lenovo integrates users’ needs with smart devices and cloud services to create the smart lifestyle of the future.",
  "intl-center-lifeDes2": "Lenovo’s cloud service platform personalizes user services by efficiently processing sounds, images, and information gathered through other sensors.",
  "intl-center-meetingTitle": "Smart Office",
  "intl-center-meetingDes1": "Lenovo is committed to providing business customers with a variety of products and intelligent scenario-based solutions to help improve operational efficiency and operations.",
  "intl-center-gameTitle": "Professional E-sports Gaming Entertainment",
  "intl-center-gameDes1": "Experience Lenovo’s new PC gaming with a line of professional e-sports devices!",
  "intl-center-gameDes2": "Lenovo’s AR and VR gaming equipment can take you to explore the jungle or travel to space. Whether you’re looking for an adventurer's paradise or a space for imagination, Lenovo AR and VR gaming devices have you covered.",
  "intl-center-madeTitle": "Smart Manufacturing",
  "intl-center-madeDes1": "Lenovo develops smart manufacturing solutions and empowers industrial upgrading.",
  "intl-center-madeDes2": "With global supply chain, Lenovo produces over 100 million devices each year. Lenovo reshapes the end-to-end smart manufacturing system through advanced technology, including intelligent supply chain management system, highly automated flexible production, model-based design, and quality control systems. AI-driven predictive analytics is dramatically enhancing the processes and decision-making in the specific value chain.",
  "intl-center-madeDes3": "Focusing on its core capabilities of smart manufacturing, Lenovo continues to promote its best practices and offer tailor-made solutions for customers in manufacturing industry.",
  "intl-center-medicalTitle": "Smart Healthcare",
  "intl-center-medicalDes1": "Lenovo uses its own digital capabilities to enable more people to access better medical resources: help hospitals and nursing homes establish a new type of smart healthcare system; stive to reach scientific treatment for chronic diseases; empower hospitals to achieve intelligent transformation.",
  "intl-center-medicalDes2": " ",
  "intl-center-educationTitle": "Smart Education",
  "intl-center-educationDes1": "With the advent of the Education Informatization 2.0, Lenovo empowers Education Informatization with AI, so that school administrators, teachers and students can enjoy the practical value of smart education. Based on core technologies such as AR/VR integration, human-computer interaction, and OCR, Lenovo developed a technical engine for smart education, based on which Lenovo offers a series of smart education solutions that empower thousands of schools.",
  "intl-center-educationDes2": " ",
  "intl-center-educationDes3": " ",
  "intl-event-title1": "A place for Lenovo users, members and fans to get together",
  "intl-event-title2": "A place to focus on technology, culture, art and thought ",
  "intl-event-title3": "Here, it’s not just Lenovo.",
  "intl-AboutUS-ban1": "•	Firearms, military and police equipment (including major components) and replicas of these items.",
  "intl-AboutUS-ban2": "•	Explosive items, including explosives, blasting equipment, fireworks and firecrackers and replicas of these items.",
  "intl-AboutUS-ban3": "•	Controlled knives and other items that may prevent others from visiting, cause personal injury or property damage to others, or disturb the order and endanger the safety of the Lenovo Future Center.",
  "intl-AboutUS-ban4": "•	Other sharp and blunt instruments.",
  "intl-AboutUS-ban5": "•	Flammable items, such as alcohol, gasoline, kerosene, diesel fuel, lighters, matches, hair gel, mousse, nail polish, hair dye, etc.",
  "intl-AboutUS-ban6": "•	Toxic or corrosive substances.",
  "intl-AboutUS-ban7": "•	Other items expressly prohibited by Chinese laws and regulations, which may affect the safety of visitors or exhibits.",
  "intl-news-title": "News",
  "intl-news-title1": "Here is news about our journey towards the intelligent future",
  "intl-aboutus-click": "	Click {here} for navigation ",
  "intl-aboutus-here": "here",
  "intl-area-sh": "Shanghai",
  "intl-area-sz": "Shenzhen",
  "intl-area-bj": "Beijing",
  "intl-area-tj": "Tianjin",
  "intl-area-tjltzngc": "Carbon Neutrality Plant",
  "intl-shcenter-citytitle": "SMART CITY",
  "intl-shcenter-citydes": "Based on “Client-Edge-Cloud-Network-Intelligence” technical architecture, Lenovo works on achieving smarter life. From top-level design, implementation, operation, and maintenance, Lenovo helps build smart city ecosystem.",
  "intl-shcenter-manufacturingtitle": "SMART MANUFACTURING",
  "intl-shcenter-manufacturingdes1": "As a leading player in the intelligent transformation, Lenovo has formed a technical and management system covering the whole value chain of manufacturing including \"Research, Supply Chain, Production, Sales and Service\". By exporting experience and technologies, Lenovo is also empowering customers to achieve intelligence. Moreover, Lenovo powers high-end manufacturing with cutting-edge computational vision technology.",
  "intl-shcenter-manufacturingdes2": " ",
  "intl-shcenter-educationtitle": "SMART EDUCATION",
  "intl-shcenter-educationdes": "Building smart campus, smart classroom, smart examination room and innovative teaching experience around core educational scenes scenarios such as teaching, learning, testing, evaluation and management.",
  "intl-shcenter-agriculturetitle": "SMART AGRICULTURE",
  "intl-shcenter-agriculturedes": "Starting from the top-level design of countryside’s digitalization,  Lenovo’s smart agricultural solution has been deployed in many areas to accelerate rural revitalization.",
  "intl-shcenter-officetitle": "SMART OFFICE",
  "intl-shcenter-officedes": "Smart office solutions including smart visitor management system, smart workplace and meetings solutions help enterprises with digital and refined management.",
  "intl-shAboutUS-VisitorsGuide1": "• No smoking in the Lenovo Future Centre.",
  "intl-shAboutUS-VisitorsGuide2": "• Group tours are capped at 15 for quality visits.",
  "intl-shAboutUS-VisitorsGuide3": "• Visitors less than 18 years old or physically challenged visitors must be accompanied by valid adults.",
  "intl-shAboutUS-VisitorsGuide4": "• No damage to buildings, facilities and exhibits, no graffiti.",
  "intl-shAboutUS-VisitorsGuide5": "• No running, chasing, climbing, or lying down in the Lenovo Future Center.",
  "intl-shAboutUS-VisitorsGuide6": "• Please confirm with the staff in advance if you would like to take photos or videos in the Lenovo Future Center.",
  "intl-shAboutUS-VisitorsGuide7": "• Please mute or vibrate your mobile phones to avoid disturbing others.",
  "intl-shAboutUS-know": "Visitor Information",
  "intl-shAboutUS-yuyue": "Reservations",
  "intl-shAboutUS-yuyue1": "• Reservations are only available for group visits currently.",
  "intl-shAboutUS-yuyue2": "• Reservations are required at least 10 days in advance.",
  "intl-shAboutUS-yuyue3": "• You will be notified via email if your reservation is successful.",
  "intl-shAbountUS-jindai": "Prohibited Items",
  "intl-shAbountUS-jindai1": "• Firearms, military, and police equipment (including major components).",
  "intl-shAbountUS-jindai2": "• Explosive devices, including explosives, blasting equipment, fireworks, and firecrackers.",
  "intl-shAbountUS-jindai3": "• Controlled knives and other items that may hinder others from visiting, result in personal injury or property damage, pose risks to the order and safety of the Lenovo Future Center.",
  "intl-shAbountUS-jindai4": "• Other sharp and blunt implements.",
  "intl-shAbountUS-jindai5": "• Flammable items, including alcohol, gasoline, kerosene, diesel fuel, lighters, matches, hair gel, mousse, nail polish, hair dye, delusterant, etc.",
  "intl-shAbountUS-jindai6": "• Toxic and corrosive substances.",
  "intl-shAbountUS-jindai7": "• Other items that are prohibited according to national laws and regulations, which may affect the safety of visitors or exhibits.",
  "intl-shAbountUS-jindai8": "• Imitations of the aforementioned items.",
  "intl-Home-shAboutUs": "Lenovo Shanghai Future Center",
  "intl-shAboutUS-ditieTitle": "Metro",
  "intl-shAboutUS-ditie": "Take Line 2 to Zhangjiang Hi-Tech Station, exit at Exit 5.",
  "intl-shAboutUS-gongjiaoTitle": "Bus",
  "intl-shAboutUS-gongjiao": "Take Pudong No. 22 or Daqiao Line 6 to Zuchongzhi Road Station, Bibo Road; Take Zhangjiang Ring Line, No. 188, Pudong No. 70 or No. 1090 to Zuchongzhi Road Station, Songtao Road.",
  "intl-shAboutUS-ClosedTime": "- Saturdays and Sundays",
  "intl-shAboutUS-Facilities1": "Parking",
  "intl-shAboutUS-Facilities2": "For your convenience, special parking places for visitors are available.",
  "intl-shAboutUS-Facilities3": "• Opening hours: Mondays to Fridays: 9:00 am – 6:00 pm.",
  "intl-shAboutUS-Facilities4": "• Reservations: Our staff will contact you for parking reservations once you receive your visit confirmation.",
  "intl-shAboutUS-Facilities5": "Reception",
  "intl-shAboutUS-Facilities6": "• Location: the reception desk, 1F, Building A, Lenovo Innovation Park.",
  "intl-shAboutUS-Facilities7": "• There is a brochure about the Lenovo Future Center at the reception desk for visitors to get an initial overview.",
  "intl-shAboutUS-Facilities8": "• There is a rest area around the reception desk on the first floor of Building A.",
  "intl-shAboutUS-Facilities9": "Lockers",
  "intl-shAboutUS-Facilities10": "• Before the visit, you can bring your belongings to the Lenovo Future Center on the 5th floor of Building A. The staff will help you to store them.",
  "intl-shAboutUS-Facilities11": "• After the visit, the staff will confirm with you and return the items to you.",
  "intl-shAboutUS-Facilities12": "• Items left in the lockers after 6:00 pm will be removed and in storage for 3 days. Unclaimed items after 3 days will be discarded.",
  "intl-shAboutUS-Facilities13": "• Please carry your valuables. If lost, at your own risk.",
  "intl-shcenter-title2": "Lenovo Future Center is an important display window of Lenovo Group's intelligent transformation strategy. At present, it has landed in Beijing and Shanghai.",
  "intl-shcenter-title2_1": " ",
  "intl-shAboutUS-title1": "We endeavor to provide you with the best visiting experience.",
  "intl-shAboutUS-title2": "Here you can understand Lenovo and learn more about our future.",
  "intl-szcenter-ittitle": "The technology architecture of New IT",
  "intl-szcenter-itdes1": "This showcase presents Lenovo’s New IT architecture: Client-Edge-Network-Cloud-Intelligence.",
  "intl-szcenter-itdes2": "You will see how tools such as Lenovo Brain, Edge AI, Few-Shot Learning (FSL), Edge Cloud Network Convergence, and High-Performance Computing (HPC) can be applied in different industries to accelerate their intelligent transformation.",
  "intl-szcenter-maketitle": "Manufacturing",
  "intl-szcenter-educationtitle": "Education",
  "intl-szcenter-educationdes1": "Lenovo is promoting the digital transformation 2.0 in education by offering end-to-end solutions composed of devices, applications, and services.",
  "intl-szcenter-educationdes2": "With diversified product portfolio including e-blackboards, AIO for teaching and researching, equipment for experiment exam rooms, Lenovo Smart Education solutions effectively enhance teaching and learning experience.",
  "intl-szcenter-citytitle": "Smart City",
  "intl-szcenter-citydes": "Smart infrastructure lays the foundation for smart city solutions, which include sanitation management, traffic relief, and crisis management. At this showcase, you will know about Lenovo’s city operation management solutions and smart park solutions which helps city managers plan around events or improve response to disasters and emergencies.",
  "intl-szcenter-ESGtitle": "ESG",
  "intl-szcenter-ESGdes1": "As a global technology leader, Lenovo is determined to create a better world not only through the products and services we offer, but also in implementation of sustainable practices. We want to ensure we’re making a positive impact in the world socially and environmentally.",
  "intl-szcenter-ESGdes2": "ESG showcase indicates the ESG practices and achievements of Lenovo. From the water-cooled data centers to the Lenovo Forest in desert and digital protection of the Yangtze River dolphin, Lenovo’s commitment to sustainable development can be reflected.",
  "intl-szcenter-citytitle": "Smart City",
  "intl-szcenter-citydes": "The smart city area showcases Lenovo's smart traffic solutions, ranging from car computing to 5G+V2X technology, as well as digital infrastructure for smart city and smart campus. By leveraging intelligent technology, Lenovo solutions empower the sustainable development of cities.",
  "intl-szcenter-financetitle": "Finance",
  "intl-szcenter-financedes": "This area presents Lenovo's intelligent solutions tailored for the finance industry, providing infrastructure for trading and low-latency use cases to safeguard the operation in finance industry.",
  "intl-Home-shAboutUs": "Lenovo Shenzhen Future Center",
  "intl-szAboutUS-ditieTitle": "Metro：",
  "intl-szAboutUS-ditie1": "A. Take Line 2 (Line 8) to Houhai Station, exit A, you can walk through the business district to the lobby (on the ground floor) of the office building, or directly out of the station through the west entrance of Lenovo Houhai Center.",
  "intl-szAboutUS-ditie2": "B. Take Line 11 to Houhai Station, vou are recommended to exit through J, go across Haide 3rd Rd. and go straight to the south for 300 meters.",
  "intl-szAboutUS-jiacheTitle": "By Bus/By Car：",
  "intl-szAboutUS-jiache": "",
  "intl-szAboutUS-ClosedTime": "- Sundays",
  "intl-szAboutUS-Facilities1": "Parking",
  "intl-szAboutUS-Facilities2": "For your convenience, special parking places for visitors are available.",
  "intl-szAboutUS-Facilities3": "• Opening hours: Mondays to Fridays: 9:00 am – 6:00 pm.",
  "intl-szAboutUS-Facilities4": "• Reservations: Our staff will contact you for parking reservations once you receive your visit confirmation.",
  "intl-szAboutUS-Facilities5": "Reception",
  "intl-szAboutUS-Facilities6": "Location: The intersection of Houhaibin Rd. and Haide 1st Rd. Lenovo Houhai Center Nanshan District, Shenzhen, Guangdong.",
  "intl-szAboutUS-Facilities7": "• There is a brochure about the Lenovo Future Center at the reception desk for visitors to get an initial overview.",
  "intl-szAboutUS-Facilities9": "Lockers",
  "intl-szAboutUS-Facilities10": "• Before the visit, you can bring your belongings to the Lenovo Future Center on the 6th floor of Building A. The staff will help you to store them.",
  "intl-szAboutUS-Facilities11": "• After the visit, the staff will confirm with you and return the items to you.",
  "intl-szAboutUS-Facilities12": "• Items left in the lockers after 6:00 pm will be removed and in storage for 3 days. Unclaimed items after 3 days will be discarded.",
  "intl-szAboutUS-Facilities13": "• Please carry your valuables. If lost, at your own risk.",
  "intl-szAboutUS-site1": "The intersection of Houhaibin Rd. and Haide 1st Rd. Lenovo Houhai Center Nanshan District, Shenzhen, Guangdong",
  "intl-Menu-shAddress": "Lenovo Shanghai Future Center, 5F, Bldg. A, Lenovo Innovation Park, No. 696 Songtao Rd., Pudong New Area, Shanghai, China",
  "intl-Menu-szAddress": "Lenovo Shenzhen Future Center, The intersection of Houhaibin Rd. and Haide 1st Rd. Lenovo Houhai Center Nanshan District, Shenzhen, Guangdong, China",
  "intl-Menu-fc": "Lenovo Beijing Future Center",
  "intl-Menu-shfc": "Lenovo Shanghai Future Center",
  "intl-card-fc": "Beijing",
  "intl-card-shfc": "Shanghai",
  "intl-card-szfc": "Shenzhen",
  "intl-card-tjfc": "Tianjin",
  "intl-card-enable2023": "2023",
  "intl-card-enable2019": "2019",
  "intl-card-enable2021": "2021",
  "intl-shAboutUS-Closed": "Closing time",
  ...tj
};
export default en_US;



// WEBPACK FOOTER //
// ./src/langConfig/en-US.js